export const formatImage = (image: string) => {
    if (image.startsWith("http")) {
        return image;
    }
    return `data:image/png;base64,${image}`;
}